<template>
    <div class="content">
        <div class="tab-container">
            <div class="d-flex">
                <div class="input-record mr-3">
                    <!-- <input type="text" placeholder="搜尋（依檔名、雜湊值、存證時間、存證人員）" id="search-input" /> -->
                    <!-- <b-icon icon="search" scale="1" class="mx-3" v-on:click="handleSearch()"></b-icon> -->
                    <b-form-input id="filter-input" v-model="filter" type="search" placeholder="搜尋（依檔名、雜湊值、存證時間、存證人員）"></b-form-input>
                </div>
                <!-- <button class="btn-primary-sm" @click="handleSearch">搜尋</button> -->
            </div>
            <div class="w-100 mt-3">
                <b-table class="history_table text-primary bg-white" :filter="filter" :items="items" :fields="fields" :sort-by.sync="sortBy" :filter-included-fields="filterOn" empty-text="查無此資料" empty-filtered-text="查無此資料" label-sort-asc="" label-sort-desc="" label-sort-clear="" :sort-desc.sync="sortDesc" sticky-header hover no-border-collapse show-empty>
                    <template #cell(fileName)="data">
                        <span class="ellipsis-td-file-lg">{{data.item.fileName}}</span>
                    </template>
                    <template #cell(detail)="data">
                        <button class="btn text-yellow text-nowrap" @click="$bvModal.show('modal-detail'),handleModal(data.item)">詳細</button>
                    </template>
                    <template #cell(download)="data">
                        <button class="btn" @click="clickDownload(data.item.proveId)">
                            <img :src="fileDownload" alt="file download img" aria-hidden="true">
                        </button>
                    </template>
                    <template #empty>
                        <div class="text-center">尚無紀錄</div>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="footer"></div>
        <b-modal id="modal-detail" title="" header-bg-variant="secondary" centered>
            <div class="d-block text-left">
                <div class="hash-table text-break text-primary mx-3">
                    <b-row>
                        <b-col cols="12" class="bg-primary">檔案名稱</b-col>
                        <b-col cols="12" class="bg-gray py-1">{{modalItems.fileName}}</b-col>
                        <b-col cols="12" class="bg-lightyellow">雜湊值</b-col>
                        <b-col cols="12" class="bg-gray py-1">{{modalItems.hash}}</b-col>
                        <b-col cols="12" class="bg-lightyellow">存證時間</b-col>
                        <b-col cols="12" class="bg-gray py-1">{{modalItems.time}}</b-col>
                        <b-col cols="12" class="bg-lightyellow">存證人員</b-col>
                        <b-col cols="12" class="bg-gray py-1">{{modalItems.person}}</b-col>
                    </b-row>
                </div>
            </div>
            <template #modal-footer>
                <div class="w-100 text-center">
                    <button class="btn-primary-sm mx-3" @click="$bvModal.hide('modal-detail')">
                        關閉
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import fileDownload from "../assets/img/icon/file_download.png";

export default {
    name: "RecordPage",
    methods: {
        handleModal(item) {
            this.modalItems = item;
        },
        handleSearch() {
            const searchVal = document.getElementById('search-input').value;
            document.location.search = `?search=${searchVal}`;
        },
        clickDownload(params) {
            let routerData = this.$router.resolve({ path: `prove?id=${params}` });
            window.open(routerData.href, '_blank');
        }
    },
    data() {
        return {
            sortBy: "index",
            sortDesc: true,
            filter: null,
            filterOn: ["fileName","hash","time","person"],
            fileDownload: fileDownload,
            fields: [{
                    key: "index",
                    sortable: true,
                    label: "項目",
                    thClass: "text-white",
                    tdClass: "align-center text-width-80",
                    class: "border-td"
                },
                {
                    key: "fileName",
                    sortable: true,
                    label: "檔案名稱",
                    thClass: "text-white",
                    tdClass: "text-width-340",
                    class: "border-td"
                },
                {
                    key: "hash",
                    sortable: true,
                    label: "雜湊值",
                    thClass: "text-white",
                    tdClass: "text-width-340",
                    class: 'border-td d-none d-lg-table-cell'
                },
                {
                    key: "time",
                    sortable: true,
                    label: "存證時間",
                    thClass: "text-white",
                    tdClass: "text-width-180",
                    class: 'border-td d-none d-lg-table-cell'
                },
                {
                    key: "person",
                    sortable: true,
                    label: "存證人員",
                    thClass: "text-white",
                    tdClass: "text-width-180",
                    class: 'border-td d-none d-lg-table-cell'
                },
                {
                    key: "detail",
                    sortable: false,
                    label: "",
                    thClass: "text-white",
                    tdClass: "text-width-80",
                    class: "border-td text-center d-table-cell d-lg-none",
                },
                {
                    key: "download",
                    sortable: false,
                    label: "下載",
                    thClass: "text-white",
                    tdClass: "text-width-80",
                    class: 'border-td text-center'
                },
            ],
            items: [],
            modalItems: {},
        };
    },
    mounted() {
        if (!sessionStorage.getItem('username') && !sessionStorage.getItem('organs')) {
            this.$router.push('/');
        }
        const search = this.$route.query.search;
        const fetchData = async () => {
            try {
                const res = await axios.get(`${process.env.VUE_APP_BACKEND_API_URL}/${search?`search?queryString=${search}`:`all`}`);
                this.items = res.data.map((d, index) => ({
                    index: index + 1,
                    fileName: d.filename,
                    hash: d.filehash,
                    time: moment.unix(Math.floor(parseInt(d.timestamp) / 1000)).format('YYYY/MM/DD HH:mm:ss'),
                    person: `${d.user.user_name} ${d.user.user_company}`,
                    download: "",
                    guid: d.GUID,
                    proveId: d.proveId,
                    _rowVariant: 'light',
                }))
            } catch (err) {
                console.log(err)
            }
        }
        fetchData()
    }
};
</script>
<style scoped>
input {
    width: 380px;
    padding: 7px 8px;
}
</style>